import L from "leaflet";

const STYLE_STORAGE_KEY = "preflight-map-basemap-style";
const GRAYSCALE_CLASS = "map-basemap-grayscale";
const STYLE_CHANGE_EVENT = "preflight-map-basemap-style-change";

function readStoredStyle(): "standard" | "grayscale" {
  try {
    return window.localStorage.getItem(STYLE_STORAGE_KEY) === "grayscale"
      ? "grayscale"
      : window.localStorage.getItem(STYLE_STORAGE_KEY) === "standard"
        ? "standard"
        : "grayscale";
  } catch {
    return "grayscale";
  }
}

export function addGrayscaleBasemapControl(map: L.Map, baseLayer: L.TileLayer): L.Control {
  let style = readStoredStyle();
  let button: HTMLButtonElement | null = null;
  const applyStyle = () => {
    baseLayer.getContainer()?.classList.toggle(GRAYSCALE_CLASS, style === "grayscale");
  };
  const renderButton = () => {
    if (!button) return;
    button.setAttribute("aria-pressed", String(style === "grayscale"));
    button.setAttribute("aria-label", style === "grayscale" ? "Farbliche Karte aktivieren" : "Graustufen aktivieren");
    button.textContent = style === "grayscale" ? "Farbig" : "Graustufen";
  };
  const syncStyle = () => {
    style = readStoredStyle();
    applyStyle();
    renderButton();
  };
  applyStyle();

  const control = new L.Control({ position: "bottomleft" });
  control.onAdd = () => {
    const container = L.DomUtil.create("div", "leaflet-bar map-basemap-style-control");
    const buttonElement = L.DomUtil.create("button", "map-basemap-style-button", container) as HTMLButtonElement;
    button = buttonElement;
    buttonElement.type = "button";
    buttonElement.title = "Graustufen-Kartenuntergrund umschalten";
    renderButton();
    window.addEventListener(STYLE_CHANGE_EVENT, syncStyle);
    buttonElement.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      style = style === "grayscale" ? "standard" : "grayscale";
      try {
        window.localStorage.setItem(STYLE_STORAGE_KEY, style);
      } catch {}
      applyStyle();
      renderButton();
      window.dispatchEvent(new Event(STYLE_CHANGE_EVENT));
    });
    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.disableScrollPropagation(container);
    return container;
  };
  control.onRemove = () => {
    window.removeEventListener(STYLE_CHANGE_EVENT, syncStyle);
    button = null;
  };
  control.addTo(map);
  return control;
}